<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <v-layout wrap justify-center>
      <v-flex px-2 xs12 sm12 md12 lg12 xl12 text-center>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout wrap>
            <v-flex xs12 pt-2>
              <v-card class="mb-1">
                <v-card-title
                  >Customer Details
                  <v-spacer></v-spacer>
                </v-card-title>
              </v-card>

              <v-card class="mb-1 pb-8" min-height="32em">
                <v-card-text>
                  <!-- <v-row class="py-2">
                    <v-col cols="12" class="pa-15 text-left">
                      <v-avatar
                        style="cursor: pointer"
                        v-if="profilepic"
                        size="150"
                      >
                        <img
                          style="object-fit: cover"
                          :src="baseURL + '/file/get/' + profilepic"
                        />
                      </v-avatar>
                    </v-col>
                  </v-row> -->
                  <v-layout justify-center wrap py-5>
                    <v-flex xs12>
                       <v-avatar
                        style="cursor: pointer"
                        v-if="profilepic"
                        size="150"
                      >
                        <img
                          style="object-fit: cover"
                          :src="baseURL + '/file/get/' + profilepic"
                        />
                      </v-avatar>
                    </v-flex>
                  </v-layout>
                  <v-tabs background-color="white" color="primary" grow>
                    <v-tab> Profile Details </v-tab>

                    <v-tab> Purchase Details </v-tab>
                    <v-tab-item>
                      <!-- <v-card color="basil" flat>
                        <v-card-text> -->
                      <v-row>
                        <v-col cols="12" md="4">
                          <v-row>
                            <v-col cols="5" class="text-left">
                              <span class="item_title">Full Name</span>
                            </v-col>
                            <v-col cols="7">
                              <span
                                v-if="customer.customerid"
                                class="item_value ma-2"
                                >{{ customer.customerid.firstName }}
                                {{ customer.customerid.lastName }}</span
                              >
                            </v-col>
                          </v-row>
                          <hr />
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-row>
                            <v-col cols="4" md="5" class="text-left">
                              <span class="item_title">Email</span>
                            </v-col>
                            <v-col cols="8" md="7">
                              <span
                                v-if="customer.customerid"
                                class="item_value ma-2"
                                >{{ customer.customerid.email }}</span
                              >
                            </v-col>
                          </v-row>
                          <hr />
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-row>
                            <v-col cols="4" md="5" class="text-left">
                              <span class="item_title">Gender</span>
                            </v-col>
                            <v-col cols="8" md="7">
                              <span
                                v-if="customer.customerid"
                                class="item_value ma-2"
                                >{{ customer.customerid.gender }}</span
                              >
                            </v-col>
                          </v-row>
                          <hr />
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-row>
                            <v-col cols="4" md="5" class="text-left">
                              <span class="item_title">Date of Birth</span>
                            </v-col>
                            <v-col cols="8" md="7">
                              <span
                                v-if="customer.customerid"
                                class="item_value ma-2"
                                >{{ customer.customerid.dob }}</span
                              >
                            </v-col>
                          </v-row>
                          <hr />
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-row>
                            <v-col cols="5" class="text-left">
                              <span class="item_title">Phone</span>
                            </v-col>
                            <v-col cols="7" v-if="customer.phone">
                              <span class="item_value ma-2">{{
                                customer.phone
                              }}</span>
                            </v-col>
                          </v-row>
                          <hr />
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-row>
                            <v-col cols="4" md="5" class="text-left">
                              <span class="item_title">Address</span>
                            </v-col>
                            <v-col cols="8" md="7">
                              <span
                                v-if="customer.customerid"
                                class="item_value ma-2"
                                >{{ customer.customerid.address }}</span
                              >
                            </v-col>
                          </v-row>
                          <hr />
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-row>
                            <v-col cols="4" md="5" class="text-left">
                              <span class="item_title">Pincode</span>
                            </v-col>
                            <v-col cols="8" md="7">
                              <span
                                v-if="customer.customerid"
                                class="item_value ma-2"
                                >{{ customer.customerid.pincode }}</span
                              >
                            </v-col>
                          </v-row>
                          <hr />
                        </v-col>
                        <!-- <v-col cols="12" md="4">
                            <v-row>
                              <v-col cols="4" md="5" class="text-left">
                                <span class="item_title">Contact Person</span>
                              </v-col>
                              <v-col cols="8" md="7">
                                <span
                                  v-if="customer.customerid"
                                  class="item_value ma-2"
                                  >{{ customer.customerid.contactPerson }}</span
                                >
                              </v-col>
                            </v-row>
                            <hr />
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-row>
                              <v-col cols="4" md="5" class="text-left">
                                <span class="item_title">City</span>
                              </v-col>
                              <v-col cols="8" md="7">
                                <span
                                  v-if="customer.customerid"
                                  class="item_value ma-2"
                                  >{{ customer.customerid.city }}</span
                                >
                              </v-col>
                            </v-row>
                            <hr />
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-row>
                              <v-col cols="4" md="5" class="text-left">
                                <span class="item_title">Place</span>
                              </v-col>
                              <v-col cols="8" md="7">
                                <span
                                  v-if="customer.customerid"
                                  class="item_value ma-2"
                                  >{{ customer.customerid.place }}</span
                                >
                              </v-col>
                            </v-row>
                            <hr />
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-row>
                              <v-col cols="5" class="text-left">
                                <span class="item_title">Pincode</span>
                              </v-col>
                              <v-col cols="7">
                                <span
                                  v-if="customer.customerid"
                                  class="item_value ma-2"
                                  >{{ customer.customerid.pincode }}</span
                                >
                              </v-col>
                            </v-row>
                            <hr />
                          </v-col> -->
                        <v-col cols="12" md="4">
                          <v-row>
                            <v-col cols="5" class="text-left">
                              <span class="item_title">Customer Status</span>
                            </v-col>
                            <v-col cols="7">
                              <span
                                v-if="customer.status == 'active'"
                                class="item_value ma-2"
                              >
                                Active
                              </span>
                              <span
                                v-else-if="customer.status == 'pending'"
                                class="item_value ma-2"
                              >
                                Pending
                              </span>
                              <span v-else class="item_value ma-2">
                                Incomplete
                              </span>
                            </v-col>
                          </v-row>
                          <hr />
                        </v-col>

                        <v-col cols="12" md="4">
                          <v-row>
                            <v-col cols="5" class="text-left">
                              <span class="item_title">Account Created</span>
                            </v-col>
                            <v-col cols="7">
                              <span class="item_value ma-2"
                                >{{ formatDate(customer.create_date) }}
                              </span>
                            </v-col>
                          </v-row>
                          <hr />
                        </v-col>
                      </v-row>
                       <v-row
                  class="justify-center pt-4"
                  v-if="customer.status != 'incomplete'"
                >
                  <span class="px-2">
                    <template>
                      <v-dialog v-model="rejectdialog" max-width="600px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn v-on="on" v-bind="attrs" outlined color="red"
                            >Reject Customer</v-btn
                          >
                        </template>
                        <v-card>
                          <v-card-title class="headline grey lighten-2">
                            Delete Confirmation
                          </v-card-title>

                          <v-card-text style="padding-bottom: 0px">
                            <v-col cols="12">
                              <span style="font-size: 16px; font-weight: 600"
                                >Please confirm that you want to Remove this
                                Customer?
                              </span>
                              <v-text-field
                                outlined
                                dense
                                v-model="remark"
                                label="Remark"
                              >
                              </v-text-field>
                            </v-col>
                          </v-card-text>
                          <v-divider></v-divider>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="error" @click="rejectdialog = false"
                              >Cancel</v-btn
                            >
                            <v-btn color="primary" @click="rejectCustomer()"
                              >Reject</v-btn
                            >
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </template>
                  </span>
                </v-row>
                      <!-- </v-card-text>
                      </v-card> -->
                    </v-tab-item>
                    <v-tab-item>
                      <v-layout wrap justify-start v-if="products.length>0">
                        <v-flex
                          xs6
                          px-2
                          py-2
                          v-for="(item, i) in products"
                          :key="i"
                        >
                          <v-card flat rounded="xl" color="#F5F7FC" outlined :to="'/Purchase/' + item.order_id ">
                            <v-layout px-sm-4 pb-1 wrap justify-center>
                              <v-flex xs12>
                                <v-layout wrap justify-center>
                                  <v-flex xs3 lg3 xl3 pa-2>
                                    <v-img
                                      :src="baseURL + '/file/get/' + item.productId.photos[0]"
                                      height="100px"
                                      contain
                                    >
                                      <template v-slot:placeholder>
                                        <v-row
                                          class="fill-height ma-0"
                                          align="center"
                                          justify="center"
                                        >
                                          <v-progress-circular
                                            indeterminate
                                            color="#FF4343"
                                          ></v-progress-circular>
                                        </v-row>
                                      </template>
                                    </v-img>
                                  </v-flex>
                                  <v-flex xs9 lg9 xl9 style="line-height: 20px">
                                    <v-layout wrap justify-center>
                                        <v-flex xs12 text-left pt-2>
                                          <span
                                            style="
                                              font-size: 16px;
                                              color: #808080;
                                            "
                                          >
                                           <b> {{ item.orderID }} </b>
                                            
                                          </span>
                                      </v-flex>
                                      <v-flex xs12 text-left pt-2>
                                        <router-link
                                          :to="
                                            '/productDetails/' + item.productId._id
                                          "
                                        >
                                          <span
                                            style="
                                              font-size: 16px;
                                              color: #808080;
                                            "
                                          >
                                            {{ item.name.slice(0, 25) }}
                                            <span v-if="item.name.length > 25">
                                              ...
                                            </span>
                                          </span>
                                        </router-link>
                                      </v-flex>
                                      <v-flex xs6 text-left>
                                        <span
                                          style="
                                            font-size: 14px;
                                            color: #000000;
                                          "
                                        >
                                          Price: ₹{{ item.price }}
                                        </span>
                                      </v-flex>
                                      <v-flex xs6 text-right>
                                        <span
                                          style="
                                            font-size: 14px;
                                            color: #fa0000;
                                          "
                                        >
                                          Discount: {{ item.discount }}%
                                        </span>
                                      </v-flex>
                                       <v-flex xs12 text-left>
                                        <span
                                          style="
                                            font-size: 14px;
                                            color: #000000;
                                          "
                                        >
                                          Offer Price: ₹{{ item.offerPrice }}
                                        </span>
                                      </v-flex>
                                      <v-flex xs12 text-left>
                                        <span
                                          v-if="
                                            (item.productOrderStatus =
                                              'ordered')
                                          "
                                          style="
                                            font-size: 14px;
                                            color: #000000;
                                          "
                                        >
                                          Ordered
                                        </span>

                                        <!-- <span
                              class="pl-5"
                              style="
                                font-family: opensanslight;
                                font-size: 12px;
                                color: #000000;
                              "
                            >
                              {{ formatDate(item.product.approved_at) }}
                            </span> -->
                                      </v-flex>
                                      <v-flex xs12 text-left >
                                        <router-link
                                          :to="
                                            '/Seller/' + item.sellerId.uid
                                          "
                                        >
                                          <span
                                            style="
                                              font-size: 16px;
                                              color: #808080;
                                            "
                                          >
                                            {{ item.shopName.slice(0, 25) }}
                                            <span v-if="item.shopName.length > 25">
                                              ...
                                            </span>
                                          </span>
                                        </router-link>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-card>
                        </v-flex>
                      </v-layout>
                      <v-layout wrap v-else justify-center pt-10>
                      <v-flex md4>
                        <h1>Oops!! No Orders found</h1>
                      </v-flex>
                    </v-layout>

                    </v-tab-item>
                  </v-tabs>
                </v-card-text>

               
              </v-card>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
//import store from "../../store";
import axios from "axios";
export default {
  data() {
    return {
      valid: true,
      companyRules: [
        (v) => !!v || "Company Name is required",
        (v) =>
          (v && v.length <= 50) ||
          "Company Name must be less than 50 characters",
      ],
      numberrules: [
        // (v) => !isNaN(parseFloat(v)) || "Number is Expected",
        (v) => v >= 0 || "Number is Expected",
      ],

      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      phoneRules: [(v) => !!v || "Phone is required"],
      datatab: null,
      customer: {
        customerid: {
          bankDetails: {},
        },
      },
      category: [],
      subcategory: [],
      products: [],
      remark: null,
      rejectdialog: false,
      showsnackbar: false,
      msg: null,
      ServerError: false,
      validateInput: null,
      timeout: 5000,
      appLoading: false,
      coverphoto: null,
      profilepic: null,
      documents: null,
      workingHours: null,
    };
  },

  beforeMount() {
    this.getCustomer();
  },
  methods: {
    nextPage() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/customer/previous/next",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          customerid: this.$route.params.id,
          type: "previous",
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$router.push("/Customer/" + response.data.data._id);
            this.getCustomer();
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    prevPage() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/customer/previous/next",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          customerid: this.$route.params.id,
          type: "next",
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$router.push("/Customer/" + response.data.data._id);
            this.getCustomer();
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },

    getCustomer() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/view/" + this.$route.params.id,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.customer = response.data.data;
            if (this.customer.customerid) {
              this.coverphoto = this.customer.customerid.coverPhoto;
              this.profilepic = this.customer.customerid.photo;
            }
            this.getPurchases();
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },

    getPurchases() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/admin/orders/products/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          uid: this.$route.params.id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.products = response.data.data;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    rejectCustomer() {
      this.rejectdialog = false;

      axios({
        url: "/user/reject",
        method: "POST",
        data: {
          id: this.$route.params.id,
          remark: this.remark,
        },
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Category Deleted";
            // this.showsnackbar = true;
            this.$router.go(-1);
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    formatDate(oldDate) {
      if (oldDate) {
        var newdateFormat = oldDate.split("T");
        var splitDate = newdateFormat[0].split("-");
        if (splitDate.count == 0) {
          return null;
        }

        var year = splitDate[0];
        var month = splitDate[1];
        var day = splitDate[2];

        return day + "/" + month + "/" + year;
      }
    },
  },
};
</script>

<style >
.item_title {
  font-weight: bold;
  font-size: 14px;
}
.item_value {
  font-size: 13px;
  color: Black;
}
.v-card__title {
  line-height: 1rem !important;
}
.titlestyle {
  padding-bottom: 0px !important;
}
a {
  text-decoration: none !important;
}
</style>